import {
    DependencyList, EffectCallback, useEffect, useMemo, useRef,
    useState,
} from "react";

export default function useUpdateEffect(handler: EffectCallback, dependencies: DependencyList) {
    const isMounting = useRef(true);

    useEffect(() => {
        if (isMounting.current) {
            return undefined;
        }
        return handler();
    }, dependencies);

    useEffect(() => {
        isMounting.current = false;
    }, []);

    return useMemo(() => ({
        get isReady() {
            return isMounting.current;
        },
        set canUpdate(value: boolean) {
            isMounting.current = !value;
        },
    }), [isMounting]);
}

interface FirstLoadProperties {
    delay?: number
}
export function useIsFirstLoad(props?: FirstLoadProperties) {
    const [isMounting, setIsMounting] = useState(true);

    useEffect(() => {
        if (props?.delay) {
            setTimeout(() => {
                setIsMounting(false);
            }, props?.delay);
        } else {
            setIsMounting(false);
        }
    }, []);

    return isMounting;
}
